import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    AbstractControl,
    ControlValueAccessor,
    FormControl,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR,
    ReactiveFormsModule,
    ValidationErrors,
    Validator
} from '@angular/forms';
import { InstrumentsQuery } from '../../../../shared/state/instruments/instruments.query';
import { of, ReplaySubject, Subject } from 'rxjs';
import { InstrumentType } from '../../../../shared/state/instruments/instrument.model';
import { takeUntil, tap } from 'rxjs/operators';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { TranslateModule } from '@ngx-translate/core';
import { AssetType } from '../../../transactions/state/transaction.model';
import { StrictTitleCasePipe } from '../../../../shared/pipes/strict-title-case.pipe';

@Component({
    selector: 'sb-asset-type-select',
    standalone: true,
    imports: [
        CommonModule,
        MatSelectModule,
        ReactiveFormsModule,
        TranslateModule,
        StrictTitleCasePipe
    ],
    templateUrl: './sb-asset-type-select.component.html',
    styleUrls: ['./sb-asset-type-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: SbAssetTypeSelectComponent
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: SbAssetTypeSelectComponent
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SbAssetTypeSelectComponent
    implements OnInit, OnDestroy, ControlValueAccessor, Validator
{
    get appearance(): string {
        return this._appearance;
    }

    @Input() set appearance(value: string) {
        this._appearance = value;
    }
    get touched(): boolean {
        return this._touched;
    }

    @Input() set touched(value: boolean) {
        if (value) {
            this.markAsTouched();
        } else {
            this._touched = value;
            this.assetTypeCtrl.markAsUntouched();
        }
    }
    constructor(
        private instrumentsQuery: InstrumentsQuery,
        private _cdr: ChangeDetectorRef
    ) {}

    unsubscribe$ = new Subject();
    private _appearance: string = 'fill';
    assetTypeCtrl = new FormControl<AssetType>(null);

    onChange = (currency) => {};

    onTouched = () => {};

    private _touched = false;

    disabled = false;

    writeValue(assetType: AssetType) {
        this.assetTypeCtrl.patchValue(assetType);
    }

    registerOnChange(onChange: any) {
        this.onChange = onChange;
    }

    registerOnTouched(onTouched: any) {
        this.onTouched = onTouched;
    }

    markAsTouched() {
        if (!this.touched) {
            this.onTouched();
            this._touched = true;
        }
    }

    setDisabledState(disabled: boolean) {
        this.disabled = disabled;
    }

    validate(control: AbstractControl): ValidationErrors | null {
        // inherit errors from control value accessor
        setTimeout(() => this.assetTypeCtrl.setErrors(control.errors));
        //this._cdr.detectChanges();
        // no custom validators implemented
        return null;
    }

    @Input() set instrumentType(value) {
        this.instrumentType$.next(value);
    }
    instrumentType$ = new ReplaySubject<InstrumentType>(1);

    assetTypes$ = of([
        'PRIVATE_EQUITY',
        'COMMERCIAL_REAL_ESTATE',
        'PRIVATE_EQUITY_FUND',
        'FIXED_INCOME'
    ]);

    ngOnInit(): void {
        this.assetTypeCtrl.valueChanges
            .pipe(
                tap((value) => {
                    this.markAsTouched();
                    this.onChange(value);
                }),
                takeUntil(this.unsubscribe$)
            )
            .subscribe();
    }
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }
}
